import MatomoMessage from '@/matomo/message/MatomoMessage';

export default class MatomoQuantityMessage {
  private message: MatomoMessage;

  private constructor(message: MatomoMessage) {
    this.message = message;
  }

  public static from(message: MatomoMessage): MatomoQuantityMessage {
      return new MatomoQuantityMessage(message);
  }

  public publishFromCart() {
    this.publishWithCartInformation(true);
  }

  public publishWithCartInformation(isInCart: boolean) {
    this.message.with(isInCart ? 1 : 0).publish();
  }
}
